/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      // Set the date we're counting down to
      const date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;

      // Time with timezone, falling back to local time if the string is unparsable
      this.countDownDate = new Date(date_string).getTime();

      if (isNaN(this.countDownDate)) {
        this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();
      }

      this.timeout = null;
    }

    connectedCallback() {
      this.daysEl = this.querySelector('.days .countdown-timer--column--number');
      this.hoursEl = this.querySelector('.hours .countdown-timer--column--number');
      this.minutesEl = this.querySelector('.minutes .countdown-timer--column--number');
      this.secondsEl = this.querySelector('.seconds .countdown-timer--column--number');

      this.onVisibilityChange = () => {
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.tick();
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    tick() {
      clearTimeout(this.timeout);

      const distance = this.countDownDate - Date.now();

      if (distance <= 0) {
        this.render(0, 0, 0, 0);
        this.expire();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.render(days, hours, minutes, seconds);

      // Re-sync on the next whole second rather than on every animation frame
      this.timeout = setTimeout(() => this.tick(), distance % 1000 || 1000);
    }

    render(days, hours, minutes, seconds) {
      CountdownTimer.setValue(this.daysEl, days);
      CountdownTimer.setValue(this.hoursEl, hours);
      CountdownTimer.setValue(this.minutesEl, minutes);
      CountdownTimer.setValue(this.secondsEl, seconds);
    }

    expire() {
      this.setAttribute('expired', '');

      if (this.dataset.hideOnExpire === 'true') {
        const section = this.closest('.countdown-banner-section') || this.closest('.countdown-banner');
        if (section) section.classList.add('countdown-banner-section--hidden');
      }

      this.dispatchEvent(new CustomEvent('countdown:expired', { bubbles: true }));
    }

    static setValue(el, value) {
      if (!el) return;
      const next = CountdownTimer.addZero(value);
      if (el.textContent !== next) el.textContent = next;
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? '0' + x : String(x);
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}
